import React, { useEffect, useState } from 'react';
import ListView from '../../components/views/listView';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import {
    HOME,
    SURVEY_PATH,
    SURVEYEDIT,
    SURVEYNEW,
} from '../../../routes/paths';
import { MasterMessage } from '../../../masters/masterMessages';
import { useLocation, useNavigate } from 'react-router-dom';
import { Chip, IconButton, Tooltip } from '@mui/material';
import { SwalCustomClass } from '../../components/general/toastSwal/swalCustomClass';
import {
    asyncDeleteSurvey,
    asyncGetSurveys,
    asyncPostExportData,
} from '../../../services/survey.service';
import EditIcon from '@mui/icons-material/Edit';
import LinkIcon from '@mui/icons-material/Link';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import DownloadIcon from '@mui/icons-material/Download';
import SubtitlesOffOutlinedIcon from '@mui/icons-material/SubtitlesOffOutlined';
import Swal from 'sweetalert2';
import { typesRedux as types } from '../../../shared/types/typesRedux';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../redux/store';
import { b64toBlob } from '../../../shared/utils/files';
import { BodySurvey } from '../../../shared/types/survey.interface';
import ModalFilters from './modalFilters';
import { useFormik } from 'formik';
import dayjs from 'dayjs';
import * as Yup from 'yup';

const SurveyList = () => {
    const dispatch: any = useDispatch();
    const navigate = useNavigate();
    const [rows, setRows] = useState<any>();
    const [lengthRows, setLengthRows] = useState<number>(0);
    const [loading, setLoading] = useState<boolean>(true);
    const [page, setPage] = useState<number>(0);
    const [pageSize, setPageSize] = useState<number>(20);
    const [isOpenFilterModal, setIsOpenFilterModal] = useState(false);
    const { surveys }: any = MasterMessage;
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const projectNameParam = queryParams.get('projectName') || '';
    const { logUser } = useSelector((state: RootState) => state.general);
    const { projectIds, type } = logUser || {};

    const [filters, setFilters] = useState({
        startDate: '',
        endDate: '',
        responseStartDate: '',
        responseEndDate: '',
    });

    useEffect(() => {
        dispatch({ type: types.resetStepper });

        asyncGetSurveys(
            page,
            pageSize,
            projectNameParam,
            filters.startDate,
            filters.endDate,
            filters.responseStartDate,
            filters.responseEndDate
        )
            .then((body: BodySurvey) => {
                if (body.items !== undefined) {
                    if (type) {
                        setRows(body.items.items);
                        setLengthRows(body.items.length);
                    }
                } else if (body.message !== undefined) {
                    SwalCustomClass.fire({
                        text: surveys[body.message],
                        icon: 'error',
                        iconColor: '#1d1d1d',
                    });
                }
            })
            .finally(() => setLoading(false));
    }, [
        page,
        pageSize,
        surveys,
        projectIds,
        projectNameParam,
        filters.startDate,
        filters.endDate,
        filters.responseStartDate,
        filters.responseEndDate,
    ]);

    useEffect(() => {
        setPage(0);
    }, [projectNameParam]);

    const deleteSurvey = (rowId: string) => {
        Swal.fire({
            title: surveys.titleInactive,
            text: surveys.messageInactive,
            icon: 'error',
            iconColor: '#1d1d1d',
            showDenyButton: true,
            denyButtonText: 'NO',
            denyButtonColor: '#1d1d1d',
            confirmButtonText: 'SI',
            confirmButtonColor: '#1d1d1d',
            customClass: 'swal-wide-class',
        }).then((response) => {
            if (response.isConfirmed) {
                asyncDeleteSurvey(rowId).then((body: any) => {
                    if (body.items !== undefined) {
                        SwalCustomClass.fire({
                            text: surveys.messageInactiveOk,
                            icon: 'success',
                            iconColor: '#1d1d1d',
                        });
                        asyncGetSurveys(page, pageSize, projectNameParam).then(
                            (body: any) => {
                                if (body.items !== undefined) {
                                    setRows(body.items.items);
                                    setLengthRows(body.items.length);
                                }
                            }
                        );
                    } else {
                        SwalCustomClass.fire({
                            text: surveys[body.message],
                            icon: 'error',
                            iconColor: '#1d1d1d',
                        });
                    }
                });
            }
        });
    };

    const exportData = async (surveyId: string) => {
        try {
            const body: any = await asyncPostExportData(
                surveyId,
                formik?.values?.startDate,
                formik?.values?.endDate
            );
            if (body.items !== undefined) {
                const blob = b64toBlob(
                    body.items,
                    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                );
                const blobUrl = URL.createObjectURL(blob);
                window.location = blobUrl as any;
                return SwalCustomClass.fire({
                    text: 'Exporte realizado',
                    icon: 'success',
                    iconColor: '#1d1d1d',
                });
            }
        } catch (error) {}
        SwalCustomClass.fire({
            text: 'No fue posible descargar los datos',
            icon: 'error',
            iconColor: '#1d1d1d',
        });
    };

    const paginator = (paginationModel: any) => {
        if (paginationModel.page !== page) {
            setPage(paginationModel.page);
        } else if (paginationModel.pageSize !== pageSize) {
            setPageSize(paginationModel.pageSize);
        }
    };

    const columns = [
        {
            field: 'code',
            headerName: 'Código',
            minWidth: 100,
            flex: 0.5,
        },
        {
            field: 'title',
            headerName: 'Titulo',
            minWidth: 120,
            flex: 1,
        },
        {
            field: 'description',
            headerName: 'Descripcion',
            minWidth: 120,
            flex: 1,
        },
        {
            field: 'status',
            headerName: 'Estado',
            minWidth: 100,
            flex: 0.5,
            align: 'center',
            headerAlign: 'center',
            renderCell: (val: any) => {
                switch (val.value) {
                    case 'active':
                        return (
                            <Chip
                                label="ACTIVO"
                                sx={{ ml: 1, fontSize: 11.5 }}
                                color="success"
                            />
                        );
                    case 'inactive':
                        return (
                            <Chip
                                label="INACTIVO"
                                sx={{ ml: 1, fontSize: 11.5 }}
                                color="error"
                            />
                        );
                    default:
                        return (
                            <Chip
                                label="EN PROCESO"
                                sx={{ ml: 1, fontSize: 11.5 }}
                                color="info"
                            />
                        );
                }
            },
        },
        {
            field: 'actions',
            headerName: 'Acciones',
            width: 150,
            sortable: false,
            disableColumnMenu: true,
            filterable: false,
            align: 'center',
            headerAlign: 'center',
            renderCell: (row: any) => (
                <>
                    <Tooltip title={`${SURVEY_PATH}/${row.id}`}>
                        <a href={`${SURVEY_PATH}/${row.id}`} target="_blank">
                            <LinkIcon
                                fontSize="medium"
                                style={{ marginTop: 5 }}
                            />
                        </a>
                    </Tooltip>
                    <Tooltip title="Descargar datos">
                        <IconButton
                            size="small"
                            onClick={() => exportData(row.id)}
                        >
                            <DownloadIcon type="submit" color="primary" />
                        </IconButton>
                    </Tooltip>
                    {type !== 'reporter' && (
                        <>
                            <Tooltip title="Editar">
                                <IconButton
                                    size="small"
                                    onClick={() =>
                                        navigate(`${SURVEYEDIT}/${row.id}`)
                                    }
                                >
                                    <EditIcon type="submit" color="primary" />
                                </IconButton>
                            </Tooltip>
                            <Tooltip title="Deshabilitar">
                                <span>
                                    <IconButton
                                        size="small"
                                        onClick={() => deleteSurvey(row.id)}
                                        disabled={row.row.status === 'inactive'}
                                    >
                                        <SubtitlesOffOutlinedIcon
                                            type="submit"
                                            color={
                                                row.row.status === 'inactive'
                                                    ? 'disabled'
                                                    : 'primary'
                                            }
                                        />
                                    </IconButton>
                                </span>
                            </Tooltip>
                        </>
                    )}
                </>
            ),
        },
    ];

    const formik = useFormik({
        initialValues: {
            startDate: '',
            endDate: '',
            responseStartDate: '',
            responseEndDate: '',
        },
        validationSchema: Yup.object().shape({
            startDate: Yup.date().nullable(),
            endDate: Yup.date()
                .nullable()
                .test(
                    'fechas-validas',
                    'Debe ingresar fecha final si hay inicial, y esta debe ser mayor.',
                    function (value) {
                        const { startDate } = this.parent;
                        if (startDate && !value) return false;
                        if (
                            startDate &&
                            value &&
                            dayjs(value).isBefore(dayjs(startDate))
                        )
                            return false;
                        return true;
                    }
                ),
            responseStartDate: Yup.date().nullable(),
            responseEndDate: Yup.date()
                .nullable()
                .test(
                    'fechas-validas-response',
                    'Debe ingresar fecha final si hay inicial, y esta debe ser mayor.',
                    function (value) {
                        const { responseStartDate } = this.parent;
                        if (responseStartDate && !value) return false;
                        if (
                            responseStartDate &&
                            value &&
                            dayjs(value).isBefore(dayjs(responseStartDate))
                        )
                            return false;
                        return true;
                    }
                ),
        }),
        onSubmit: (values) => {
            setFilters({
                startDate: values.startDate
                    ? dayjs(values.startDate).toISOString()
                    : '',
                endDate: values.endDate
                    ? dayjs(values.endDate).toISOString()
                    : '',
                responseStartDate: values.responseStartDate
                    ? dayjs(values.responseStartDate).toISOString()
                    : '',
                responseEndDate: values.responseEndDate
                    ? dayjs(values.responseEndDate).toISOString()
                    : '',
            });
            SwalCustomClass.fire({
                icon: 'success',
                title: 'Filtros aplicados exitosamente',
            });
            setIsOpenFilterModal(false);
        },
    });

    return (
        <>
            <ListView
                title={surveys.titleList}
                titleButtonAdd={'Agregar'}
                startIconButtonAdd={<AddCircleIcon />}
                onClickAdd={() => navigate(SURVEYNEW)}
                onClickBack={() => navigate(HOME)}
                columns={columns}
                projectKey={projectNameParam}
                rows={rows}
                rowCount={lengthRows}
                disableRow={true}
                loading={loading}
                onSetPage={(paginationModel: any) => paginator(paginationModel)}
                enabledButtonGeneral
                titleButtonGeneral="Filtros"
                startIconButtonGeneral={<FilterAltIcon />}
                onClickButtonGeneral={() => setIsOpenFilterModal(true)}
            />
            <ModalFilters
                open={isOpenFilterModal}
                onClose={() => setIsOpenFilterModal(false)}
                formik={formik}
            />
        </>
    );
};

export default SurveyList;
